module.exports = __webpack_public_path__ + "static/media/twitter.d4731f86.svg";